import THEME from '../../../theme.js';
// Shared color palette for the General Management insight tabs.
// Sourced from the corporate brand palette: lilla, turkis, ler, salviegrøn, mauve.
// Charts use solid fills only (no gradients) to keep the look calm and professional.
export const INSIGHTS_PALETTE = {
    lilla: '#7370C0',
    turkis: '#4F9DAD',
    ler: '#C18A63',
    salviegron: '#6FAE8C',
    mauve: '#B57F9E',
    // Semantic aliases - chart series default to lilla, paired with turkis
    primary: '#7370C0',
    primarySoft: '#9B98D0',
    primaryMuted: '#D1CFE8',
    secondary: '#4F9DAD',
    secondarySoft: '#9DC3CC',
    accent: '#B57F9E',
    // Status colors mapped onto the brand palette
    positive: '#6FAE8C',
    warning: '#C18A63',
    caution: '#B57F9E',
    danger: '#B57F9E',
    neutral: '#4F9DAD',
    // Categorical series palette (in brand order)
    series: ['#7370C0', '#4F9DAD', '#C18A63', '#6FAE8C', '#B57F9E'],
    // Surfaces / typography
    surface: '#FFFFFF',
    surfaceMuted: THEME.SURFACE_MUTED,
    border: THEME.BORDER,
    text: '#1F2A44',
    textMuted: THEME.TEXT_MUTED,
    grid: THEME.BORDER,
};
//# sourceMappingURL=palette.js.map